module.exports = __webpack_public_path__ + "static/media/mobile.98883ddd.png";